import { Switch, Route, Redirect } from "react-router-dom";

import Home from "./pages/Home";
import UserManagement from "./pages/UserManagement";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Ga4Management from "./pages/Ga4Management";
import ActivityLogging from "./pages/ActivityLogs"
import Main from "./components/layout/Main";
import PrivateRoute from "./middleware/PrivateRoute";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import TeamManagement from "./pages/TeamManagement";
import { AnalyticsManagement } from "./pages/AnalyticsManagement";
import AiProviderManagement from "./pages/AiProviderManagement";
import SubscriptionPlansManagement from "./pages/SubscriptionPlansManagement";
import UserSubscriptionsManagement from "./pages/UserSubscriptionsManagement";
import PolarsQuotaRequestsManagement from "./pages/PolarsQuotaRequestsManagement";
import AiProviders from "./pages/AiProviders";
function App() {
  return (
    <Switch>
      <Route exact path="/sign-in" component={SignIn} />
      <Route exact path="/sign-up" component={SignUp} />

      <Route
        path="/"
        render={() => (
          <Main>
            <Switch>
              <PrivateRoute exact path="/dashboard" component={Home} />
              <PrivateRoute exact path="/team_management" component={TeamManagement} />
              <PrivateRoute exact path="/user_management" component={UserManagement} />
              <PrivateRoute exact path="/billing" component={UserSubscriptionsManagement} />
              {/* <PrivateRoute exact path="/rtl" component={Rtl} /> */}
              <PrivateRoute exact path="/ga4_management" component={Ga4Management} />
              <PrivateRoute exact path="/activity_logging" component={ActivityLogging} />
              <PrivateRoute exact path="/analytics_management" component={AnalyticsManagement} />
              <PrivateRoute exact path="/ai_provider_management" component={AiProviderManagement} />
              <PrivateRoute exact path="/subscription_plans" component={SubscriptionPlansManagement} />
              <PrivateRoute exact path="/user_subscriptions" component={UserSubscriptionsManagement} />
              <PrivateRoute exact path="/polars_quota_requests" component={PolarsQuotaRequestsManagement} />
              <PrivateRoute exact path="/ai_providers" component={AiProviders} />

              <PrivateRoute exact path="/profile" component={Profile} />
              <Redirect to="/dashboard" />
            </Switch>
          </Main>
        )}
      />
    </Switch>
  );
}

export default App;
